export function assertString(value) {
  if (!(value || typeof value === 'string')) {
    throw new Error(`Expected a string, but got ${typeof value}`);
  }
}
export function assertNonNullable(value) {
  if (!value) {
    throw new Error(`Expected a non-nullable, but got ${typeof value}`);
  }
}
//# sourceMappingURL=invariants.js.map